export { default } from './CanvasArea';